module.exports = __webpack_public_path__ + "_assets/img/LimitedTimeMission-Stpes-Detail-icon.16d2fb77.svg";